import api from '../../api/leadRealAPI'
import router from '../../router'
import Vue from 'vue'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

export default {
  namespaced: true,

  state: {
    userData: null,
    properties: null,
    language: router.currentRoute.params.lang,
    selectedDetails: null,
    propertyMap: null,
    favorite: null,
    page404: null,
    newStatus: null,
    favoriteList: null,
    browser: null,
    recommended: null,
    recentRentalProperties: null,
    reportStatus: null,
    company: null
  },

  getters: {
    user: state => state.userData,
    propertyData: state => state.propertyData,
    properties: state => state.properties,
    propertiesDetails: state => state.selectedDetails,
    propertyMap: state => state.propertyMap,
    favorite: state => state.favorite,
    page404: state => state.page404,
    favoriteList: state => state.favoriteList,
    browser: state => state.browser,
    newStatus: state => state.newStatus,
    recommended: state => state.recommended,
    recentRentalProperties: state => state.recentRentalProperties,
    reportStatus: state => state.reportStatus,
    company: state => state.company
  },

  mutations: {
    setProperties (state, properties) {
      state.properties = properties
    },
    setProperty (state, propertyData) {
      state.propertyData = propertyData
    },
    setNewStatus (state, newStatus) {
      state.newStatus = newStatus
    },
    setPropertyDetails (state, selectedDetails) {
      state.selectedDetails = selectedDetails
    },
    setPropertyMap (state, propertyMap) {
      state.propertyMap = propertyMap
    },
    setFavorite (state, favorite) {
      state.favorite = favorite
    },
    setHide (state, page404) {
      state.page404 = page404
    },
    setFavoriteList (state, favoriteList) {
      state.favoriteList = favoriteList
    },
    setBrowser (state, browser) {
      state.browser = browser
    },
    setRecommended (state, recommended) {
      state.recommended = recommended
    },
    setRecentRentalProperties (state, recentRentalProperties) {
      state.recentRentalProperties = recentRentalProperties
    },
    setReportStatus (state, reportStatus) {
      state.reportStatus = reportStatus
    },
    setCompany (state, company) {
      state.company = company
    }
  },

  actions: {
    propertyDetails ({ dispatch, commit }, data) {
      commit('setPropertyDetails', null)
      let activeLanguage = data.lang
      switch (activeLanguage) {
        case 'ja':
          activeLanguage = 'name_ja'
          break
        case 'en':
          activeLanguage = 'name_en'
          break
        case 'zh-cn':
          activeLanguage = 'name_zh-cn'
          break
        case 'zh-tw':
          activeLanguage = 'name_zh-tw'
          break
      }
      api
        .get('/member/specificProperty/' + data.id)
        .then(response => {
          const propertyListDatas = response.data.data
          let propertiesDisplay = null
          const propertyDetail = propertyListDatas.property
          const language = ['日本語', '英語', '繁体字', '簡体字']
          const status = propertyListDatas.property_types
          const languages = activeLanguage
          const images = []
          let imageList = []
          language.forEach(element => {
            if (propertyDetail[element].language === activeLanguage && status[languages] === 'published') {
              propertiesDisplay = propertyDetail[element]
              propertyDetail[element].property_category = response.data.data.property_category
              propertyDetail[element].yields = propertyDetail[element].yields !== null ? propertyDetail[element].yields : null
              propertyDetail[element].type = propertyListDatas.type
              if (propertyDetail[element].properties_images !== null) {
                imageList = propertyDetail[element].properties_images
                imageList.forEach(element => {
                  images.push({
                    url: element.images.url,
                    label: element.label
                  })
                })
                propertiesDisplay.properties_images = images
              } else {
                propertiesDisplay.properties_images = [1]
              }
            }
          })
          let visible404 = false
          if (propertiesDisplay === null) {
            visible404 = true
          }
          commit('setHide', visible404)
          propertiesDisplay.newStatus = response.data.data.report_status
          commit('setPropertyDetails', propertiesDisplay)
          commit('setCompany', propertyListDatas.company)
          dispatch('browseHistory', propertiesDisplay.property_id)
        })
        .catch(() => {
          const visible404 = true
          commit('setHide', visible404)
        })
    },
    favoriteAdd ({ dispatch }, data) {
      api
        .post('member/favoriteAdd/', data)
        .then(response => {
          dispatch('favoriteExist', response.data.data.property_id)
        })
    },
    recommendedProperty ({ state, commit }) {
      var language = { language: router.currentRoute.params.lang }
      api
        .post('member/recommendedProperty/', language)
        .then(response => {
          const propertyList = response.data.data
          const properties = []
          switch (language.language) {
            case 'ja':
              language = 'name_ja'
              break
            case 'en':
              language = 'name_en'
              break
            case 'zh-cn':
              language = 'name_zh-cn'
              break
            case 'zh-tw':
              language = 'name_zh-tw'
              break
          }
          propertyList.forEach(element => {
            if (element.property.length > 0) {
              const property = element.property.filter(value => value.language === language)
              property[0].type = element.type
              property[0].report_status = element.report_status
              property[0].property_category = element.property_category
              property[0].prefecture = element.prefecture
              properties.push(property)
            }
          })
          commit('setRecommended', properties)
        })
    },
    getRecentRentalProperties ({ state, commit }) {
      api
        .get(`member/properties/recent/rental/${router.currentRoute.params.lang}/`)
        .then(response => {
          commit('setRecentRentalProperties', response.data.data)
        })
    },
    loadPropertyMap ({ state, commit }, { language, type }) {
      api
        .get(`propertyMap/${language}/${type}`)
        .then(response => {
          commit('setPropertyMap', response.data)
        })
        .catch(() => {})
    },
    favoriteExist ({ commit }, data) {
      const dataValue = { id: data, language: router.currentRoute.params.lang }
      api
        .post('member/favoriteSpecific/', dataValue)
        .then(response => {
          commit('setFavorite', response.data.data)
        })
    },

    reportStatusData ({ commit }) {
      var language = { language: router.currentRoute.params.lang }
      api
        .get('member/report_status/')
        .then(response => {
          const propertyList = response.data.data
          const properties = []
          switch (language.language) {
            case 'ja':
              language = 'name_ja'
              break
            case 'en':
              language = 'name_en'
              break
            case 'zh-cn':
              language = 'name_zh-cn'
              break
            case 'zh-tw':
              language = 'name_zh-tw'
              break
          }
          propertyList.forEach(element => {
            if (element.property.length > 0) {
              const property = element.property.filter(value => value.language === language)
              property[0].type = element.type
              property[0].report_status = element.report_status
              property[0].property_category = element.property_category
              property[0].prefecture = element.prefecture
              properties.push(property)
            }
          })
          commit('setReportStatus', properties)
        })
    },

    favoriteListFunction ({ state, commit }) {
      api
        .get('member/favoriteList/')
        .then(response => {
          const propertyList = response.data.data
          commit('setFavoriteList', propertyList)
        })
    },
    propertyList ({ state, commit }, { language, type = 'business' }) {
      api
        .get(`member/properties/${type}`)
        .then(response => {
          const propertyList = response.data.data
          const properties = []
          const status = []
          propertyList.forEach((element, i) => {
            status.push(element)
            if (element.property.length > 0) {
              const property = element.property.filter(value => value.language === `name_${language}`)
              property[0].type = element.type
              property[0].report_status = element.report_status
              property[0].property_category = element.property_category
              property[0].prefecture = element.prefecture
              properties.push(property)
            }
          })
          commit('setNewStatus', status)
          commit('setProperties', properties.filter(value => value.length > 0))
        })
        .catch(() => {})
    },
    browseHistory ({ state, commit }, value) {
      var newID = []
      const browserHistory = value
      const propertyId = Vue.$cookies.get('browseHistory')
      if (propertyId !== null) {
        newID = propertyId.split(',')
        if (newID.includes(browserHistory.toString()) === false) {
          if (value !== null) { newID.push(browserHistory) }
        } else if (newID.includes(browserHistory.toString()) === true) {
          const index = newID.indexOf(browserHistory.toString())
          if (index > -1) {
            newID.splice(index, 1)
          }
          if (value !== null) { newID.push(browserHistory) }
        }
      } else {
        if (value !== null) { newID.push(browserHistory) }
      }
      Vue.$cookies.set('browseHistory', newID)
    },
    browseHistoryList ({ state, commit }) {
      let newID = []
      const propertyId = Vue.$cookies.get('browseHistory')
      if (propertyId !== null) {
        newID = propertyId.split(',')
      }
      const data = { newID: newID }
      api
        .post('member/browserList/', data)
        .then(response => {
          const propertyList = response.data.data
          if (!state.language) {
            state.language = 'name_ja'
          }
          var language = { language: router.currentRoute.params.lang }
          const properties = []
          const propertyLists = []
          switch (language.language) {
            case 'ja':
              language = 'name_ja'
              break
            case 'en':
              language = 'name_en'
              break
            case 'zh-cn':
              language = 'name_zh-cn'
              break
            case 'zh-tw':
              language = 'name_zh-tw'
              break
          }

          const saveID = data.newID.reverse()

          saveID.forEach(element => {
            const propertyListArray = propertyList.filter(value => value.id.toString() === element)
            if (propertyListArray.length > 0) {
              propertyLists.push(propertyListArray[0])
            }
          })
          propertyLists.forEach(elements => {
            if (elements.property.length > 0 && elements.property_types[language] === 'published') {
              const property = elements.property.filter(value => value.language === language)
              property[0].type = elements.type
              property[0].report_status = elements.report_status
              property[0].property_category = elements.property_category
              property[0].prefecture = elements.prefecture
              properties.push(property)
            }
          })
          commit('setBrowser', properties.filter(value => value.length > 0))
        })
    }
  }
}
